export const ExtensionCheck = (extension) => {
  switch (extension) {
    case "jpg":
    case "jpeg":
    case "png":
    case "tiff":
    case "gif":
      return "image";
    case "wav":
    case "mp3":
    case "aac":
    case "flac":
      return "audio";
    case "mp4":
    case "mov":
    case "webm":
      return "video";
    case "txt":
    case "json":
    case "csv":
      return "text";
    default:
      return "image";
  }
};
